<template>
  <q-page padding>
    <div>
      <div class="row col-12 justify-between align-center">
        <p class="text-h6 text-brand-1 text-weight-bolder">
          Ferramentas Checkagem
        </p>
      </div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-2">
          Unidade:
          <ListaUnidadesSelect class="input-new-design" />
        </div>

        <div class="col-md-2 q-ml-sm">
          Código:
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.codigo"
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Descrição
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.descricao"
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Patrimônio
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.patrimonio"
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Status

          <q-select
            class="input-new-design"
            dense
            outlined
            map-options
            option-value="value"
            option-label="label"
            emit-value
            v-model="filtros.status"
            :options="status"
          />
        </div>

        <div class="col-md-1 q-ml-sm q-mt-lg">
          <q-btn
            @click="getDados()"
            icon="filter_alt"
            no-caps
            style="background-color: #7ab9e0; border-radius: 8px; color: white"
            label="Filtrar"
          />
        </div>
      </div>

      <q-table
        v-if="isReady"
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="tableRows"
        :loading="disable"
        dense
        :columns="columns"
        v-model:pagination="pagination"
        class="tabela-tamanho-fixo q-mt-md"
        row-key="ferramenta"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template #body-cell-etiqueta="props">
          <q-td>
            <q-btn
              icon="qr_code"
              flat
              square
              dense
              style="
                color: #fff;
                background: #8bcfde;
                border-radius: 6px;
                padding: 5px;
                margin-left: 6px;
              "
              @click="recebeDadosQrCode(props.row)"
            />
          </q-td>
        </template>
        <template #body-cell-ferramenta="props">
          <q-td :props="props" class="cell-wrap">
            {{ props.row.ferramenta }}
          </q-td>
        </template>
        <template #body-cell-descricao="props">
          <q-td :props="props" class="cell-wrap descricao-produto">
            {{ props.row.descricao }}
          </q-td>
        </template>
      </q-table>

      <div
        v-if="isReady && tableRows.length > 0"
        class="row justify-start q-mt-md"
      >
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <q-dialog v-model="qrcodeModal" :persistent="true">
      <q-card style="border-radius: 20px; width: 765px">
        <q-card-section class="row items-center q-pb-none">
          <q-space />
          <q-btn
            color="brand-5"
            icon="close"
            size="12px"
            flat
            round
            dense
            @click="qrMobile = false"
            v-close-popup
          />
        </q-card-section>
        <div class="row col-12 text-brand-5 text-weight-bold q-pl-lg">
          <span class="text-body1 text-weight-bold">Etiqueta do Produto</span>
        </div>
        <div class="row col-12 q-pa-lg">
          <div class="col-5">
            <QrCode
              :value="codigoQrCode"
              :size="qrMobile == true ? 100 : 190"
            />
          </div>
          <div class="col text-weight-bolder">
            <div
              style="
                border: 3px solid #707070;
                height: 100px;
                border-radius: 10px;
              "
              class="row col-12 q-pa-sm"
            >
              <span class="qrcode-text">
                {{ dadosQrCode?.nome?.toUpperCase() }}
              </span>
            </div>
            <div class="row col-12 q-mt-xs">
              <div
                style="
                  border: 3px solid #707070;
                  height: 85px;
                  border-radius: 10px;
                "
                class="row col justify-center items-center q-pa-sm"
              >
                <span class="qrcode-text">{{
                  "PATRIMONIO: " + dadosQrCode.patrimonio
                }}</span>
              </div>
              <div
                style="
                  border: 3px solid #707070;
                  height: 85px;
                  border-radius: 10px;
                  overflow: hidden;
                  overflow-y: scroll;
                "
                class="row col items-center q-ml-xs q-pa-sm"
              >
                <span class="qrcode-text">{{
                  "CODIGO: " + dadosQrCode?.codigo?.toUpperCase()
                }}</span>
              </div>
            </div>
          </div>
          <div class="row col-12 justify-end q-mt-lg">
            <div>
              <q-btn
                label="Imprimir"
                color="black"
                no-caps
                icon="print"
                dense
                @click="imprimir()"
              />
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import QrCode from "../components/QrCode.vue";
import { useRouter } from "vue-router";

const columns = [
  {
    name: "ferramenta",
    label: "Código",
    field: "ferramenta",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: "descricao",
    align: "left",
  },
  {
    name: "numero_patrimonio",
    label: "Patrimônio",
    field: "numero_patrimonio",
    align: "left",
  },
  {
    name: "etiqueta",
    label: "Etiqueta",
    field: "etiqueta",
    align: "left",
  },
];

export default {
  components: { QrCode, ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(false);
    const router = useRouter();
    const isReady = ref(false);

    const filtros = ref({
      codigo: "",
      descricao: "",
      patrimonio: "",
      status: "",
    });

    const dadosQrCode = ref({
      codigo: "",
      nome: "",
      patrimonio: "",
    });

    const status = ref([
      { label: "Todos", value: "" },
      { label: "Disponível", value: "disponivel" },
      { label: "Em Uso", value: "uso" },
      { label: "Manutenção", value: "manutencao" },
      { label: "Manutenção Garantia", value: "manutencao_garantia" },
      { label: "Removida", value: "removida" },
      { label: "Reativação", value: "reativacao" },
      { label: "Desmobilizada", value: "desmobilizada" },
      { label: "Retorno em Garantia", value: "retorno_em_garantia" },
      { label: "Descartada", value: "descartada" },
      { label: "Furto", value: "furto" },
      { label: "Sucata", value: "sucata" },
      { label: "Aguardando Reparo", value: "aguardando_reparo" },
      { label: "Calibração", value: "calibracao" },
      { label: "Aguardando Calibração", value: "aguardando_calibracao" },
    ]);

    const qrMobile = ref(false);
    const qrcodeModal = ref(false);
    const codigoQrCode = ref("");

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 0,
    });

    const tableRows = computed(() => {
      return Array.isArray(rows.value) ? rows.value : [];
    });

    const pagesNumber = computed(() => {
      if (!pagination.value.rowsNumber || !pagination.value.rowsPerPage)
        return 1;
      return Math.ceil(
        pagination.value.rowsNumber / pagination.value.rowsPerPage
      );
    });

    const getDados = async (page = 1, rowsPerPage = 15) => {
      if (!store.state.org?.unidadeData?.id) {
        quasar.notify({
          message: "Unidade não selecionada",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        return;
      }

      disable.value = true;

      try {
        const response = await store.dispatch("fer/getFerramentaQr", {
          vendor_id: store.state.org.unidadeData.id,
          page: page,
          per_page: rowsPerPage,
          codigo: filtros.value.codigo || "",
          descricao: filtros.value.descricao || "",
          patrimonio: filtros.value.patrimonio || "",
          status: filtros.value.status || "",
        });

        const data = response?.data?.result?.data;

        if (data && typeof data === "object" && !Array.isArray(data)) {
          rows.value = Object.values(data);
        } else if (Array.isArray(data)) {
          rows.value = data;
        } else {
          rows.value = [];
        }

        pagination.value.page = response?.data?.result?.current_page || page;
        pagination.value.rowsPerPage =
          response?.data?.result?.per_page || rowsPerPage;
        pagination.value.rowsNumber = response?.data?.result?.total || 0;
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        rows.value = [];
        pagination.value.rowsNumber = 0;

        quasar.notify({
          message: "Erro ao procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      } finally {
        disable.value = false;
        isReady.value = true;
      }
    };

    const recebeDadosQrCode = (dados) => {
      try {
        dadosQrCode.value.nome = dados?.descricao || "";
        dadosQrCode.value.patrimonio = dados?.numero_patrimonio || "";
        dadosQrCode.value.codigo = dados?.ferramenta || "";

        codigoQrCode.value = dadosQrCode.value.codigo;
        qrcodeModal.value = true;
      } catch (error) {
        console.error("Erro ao gerar QR Code:", error);
        quasar.notify({
          message: "Erro ao gerar etiqueta",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      await getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const imprimir = () => {
      router.push({
        name: "imprimir-etiqueta-ferramenta",
        params: {
          nome: dadosQrCode.value.nome,
          patrimonio: dadosQrCode.value.patrimonio,
          codigo: dadosQrCode.value.codigo,
        },
      });
    };

    watch(
      () => pagination.value.page,
      async () => {
        if (isReady.value) {
          await handleRequest();
        }
      }
    );

    onMounted(async () => {
      let attempts = 0;
      const maxAttempts = 50;

      while (attempts < maxAttempts && !store.state.org?.unidadeData?.id) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        attempts++;
      }

      if (store.state.org?.unidadeData?.id) {
        await getDados();
      } else {
        isReady.value = true;
      }
    });

    return {
      rows,
      tableRows,
      columns,
      filtros,
      dadosQrCode,
      status,
      qrMobile,
      qrcodeModal,
      codigoQrCode,
      pagination,
      disable,
      isReady,
      pagesNumber,
      getDados,
      handleRequest,
      imprimir,
      recebeDadosQrCode,

      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>

<style scoped>
.cell-wrap {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}
.descricao-produto {
  max-width: 400px;
}
</style>
